import FetchHelpers from '../../utils/FetchHelpers';
import formUrl from '../../utils/routes';
import { decamelize } from '../../utils/keysConverter';

export default {
  load(params) {
    const url = formUrl('/api/v1/admin/transactions');

    return FetchHelpers.get(url, decamelize(params));
  },
  show(id) {
    const url = formUrl(`/api/v1/admin/transactions/${id}`);

    return FetchHelpers.get(url);
  },

  update(id, params) {
    const url = formUrl(`/api/v1/admin/transactions/${id}`);

    return FetchHelpers.put(url, params);
  },
};
